import { ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * @deprecated use `cn`
 */
export function classNames(...classes: (string | null | undefined)[]): string {
  return twMerge(classes);
}

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
